module.exports = __webpack_public_path__ + "images/citiwelcome067a801f0bbeb6e6935b98bcdddb7552.png";